import React, { useState, useEffect } from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  Image,
  Text,
  View
} from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { COLORS, FONTS, IMAGES } from '../constants';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialIcons } from '@expo/vector-icons';

import { Today } from "../components"

export default function BMIResultScreen({ route }) {
  const navigation = useNavigation();

  const [state, setState] = useState({
    height: route.params.heightKey !== "" ? route.params.heightKey : "",
    mass: route.params.massKey !== "" ? route.params.massKey : "",
    resultNumber: 0,
    resultText: "",
    icon: ""
  });

{  /* console.log(state) */
}
  const handleCalculate = () => {
    // let heightWithDecimal = ((state.height).toString()).replace(",", ".")
    // let imc = ((state.mass) / heightWithDecimal ** 2).toFixed(2);
    
    let imc = (((state.mass) / state.height ** 2) * 10000).toFixed(2);
    // console.log(imc)

    setState({ resultNumber: imc })

    if (imc < 18.5) {
      setState({
        resultNumber: imc,
        resultText: "Niedowaga",
        resultIcon: IMAGES.notesIcon
      });
    } else if (imc > 18.5 && imc < 25) {
      setState({
        resultText: "Waga w normie",
        resultNumber: imc,
        resultIcon: IMAGES.medalIcon
      });
    } else if (imc >= 25 && imc < 30) {
      setState({
        resultNumber: imc,
        resultText: "Nadwaga",
        resultIcon: IMAGES.notesIcon
      });
    } else {
      setState({
        resultNumber: imc,
        resultText: "Otyłośc",
        resultIcon: IMAGES.speechIcon
      });
    }
  };

  const onScreenLoad = () => {
    if (route.params.heightKey !== "" && route.params.massKey !== "") {
      setState({
        height: route.params.heightKey,
        mass: route.params.massKey,
      });
      handleCalculate();
    }
    else {
      setState({
        resultNumber: "Błąd danych",
        resultText: "...",
        resultIcon: IMAGES.speechIcon
      });
    }
  }

  useEffect(() => {
    onScreenLoad();
  }, [])

  return (
    <>
      <View style={styles.container}>
        <Text style={styles.titleText}>
          TWOJE BMI
        </Text>
        <Text style={{ paddingVertical: 10 }}>
          {<Today />}
        </Text>

        <LinearGradient
          colors={['#323638', '#232526']}
          style={styles.shieldBg}
        >
          <LinearGradient
            colors={['#232526', '#404445', '#323638']}
            style={styles.concave}
          />

          <LinearGradient
            colors={['#F8A402', '#CC8700']}
            style={[styles.shield, styles.shadowProp]}
          >
            <Image
              source={state.resultIcon}
              style={styles.resultIcon}
            />
            <Text style={styles.infoText}>Współczynnik</Text>
            <Text style={styles.titleText}>{state.resultNumber}</Text>

            <Text style={styles.infoText}>rezultat</Text>
            <Text style={styles.titleText}>{state.resultText}</Text>

          </LinearGradient>

          <TouchableOpacity
            onPress={() => navigation.goBack()}
          >
            <LinearGradient
              colors={['rgba(0,0,0,0.2)', 'transparent']}
              style={[styles.backBtn, styles.shadowProp]}
            >
              <MaterialIcons name="reset-tv" size={24} color={COLORS.light} />
            </LinearGradient>
          </TouchableOpacity>

        </LinearGradient>

        {(state.resultText === "...") ? (
          <Text style={
            {
              color: COLORS.primary,
              fontSize: 12,
              textAlign: 'center',
              marginTop: 10
            }
          }>
            Wprowadziłeś nieprawidłowe wartości. {"\n"}
            Wzrost podaj w meterch a wagę w kilogramach.
          </Text>
        ) : (
          null
        )};

        <LinearGradient
          colors={['rgba(0,0,0,0.8)', 'transparent']}
          style={styles.button}>
        </LinearGradient>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.background,
  },
  shieldBg: {
    flex: 0,
    minWidth: 300,
    minHeight: 400,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
    borderRadius: 30,
  },
  concave: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 15,
    minWidth: 260,
    height: 20,
    borderRadius: 10,
    marginHorizontal: 20,
  },
  shield: {
    flex: 0,
    minWidth: 200,
    minHeight: 300,
    backgroundColor: COLORS.accent,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 20,
    paddingVertical: 10,
    marginHorizontal: 30,
    paddingHorizontal: 20,
    borderRadius: 30,
  },
  resultIcon: {
    position: 'absolute',
    top: -20,
    width: 80,
    height: 80
  },
  backBtn: {
    width: 80,
    height: 40,
    backgroundColor: COLORS.background,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 2,
    borderRadius: 10,
  },
  shadowProp: {
    shadowColor: COLORS.background,
    shadowOffset: {
      width: -4,
      height: 6
    },
    shadowOpacity: 0.4,
    shadowRadius: 3,
  },
  infoText: {
    color: COLORS.primary,
    fontWeight: 100,
    paddingVertical: 20,
    fontSize: 24,
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle,
    color: COLORS.secondary,
    paddingVertical: 10
  },
})